
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Qui le fabrique?`}</em></p>
    <p>{`Ce vaccin a été produit par l’Institut des produits biologiques de Pékin et la
compagnie Sinopharm, qui appartient à l’Etat chinois. Son vrai nom? BBIP-CorV.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;